import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate('/auth'); return; }
    (async () => {
      try {
        const u = await googleExchange(match[1]);
        window.history.replaceState(null, '', window.location.pathname);
        toast.success(`Welcome, ${u.name}`);
        navigate(u.role === 'admin' ? '/admin' : '/account');
      } catch {
        toast.error('Google sign-in failed');
        navigate('/auth');
      }
    })();
  }, []);

  return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground font-mono text-sm">Completing sign-in…</div>;
}
